export default __webpack_public_path__ + "static/brand_01-7f10ca1036be0bcf9306b2b788179534.png";